/*
  HerbFX — interaktive Erweiterungen für HerbTCG
  ---------------------------------------------
  Wird von snippets/herb-fx.liquid geladen. Die Konfiguration kommt aus
  window.HerbFX (Theme-Einstellungen), jedes Modul prüft seinen Schalter
  selbst und bricht sauber ab, wenn die nötigen Elemente fehlen.

  Module:
    1. Scroll-Fortschritt + Zurück-nach-oben
    2. Holo-Karteneffekt (3D-Tilt + Folienglanz)
    3. Wunschliste (localStorage + Schublade + Header-Zähler)
    4. Warenkorb-Effekte (Konfetti + Bild fliegt in den Warenkorb)
    5. Gratisversand-Fortschritt
    6. Zuletzt angesehen
    7. Sticky-Kaufleiste auf Produktseiten
    8. Suche per Tastenkürzel
*/

(function () {
  'use strict';

  var config = window.HerbFX || {};
  var settings = config.settings || {};
  var strings = config.strings || {};
  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer =
    window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* =============================================================
     Hilfsfunktionen
     ============================================================= */

  function storageGet(key, fallback) {
    try {
      var raw = window.localStorage.getItem(key);
      return raw ? JSON.parse(raw) : fallback;
    } catch (e) {
      return fallback;
    }
  }

  function storageSet(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      /* z.B. privater Modus – Feature degradiert still */
    }
  }

  // Formatiert Beträge in Cent anhand von shop.money_format.
  function formatMoney(cents) {
    var format = config.moneyFormat || '{{amount}}';
    var value = (cents || 0) / 100;

    function withDelimiters(amount, precision, thousands, decimal) {
      var fixed = amount.toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return precision > 0 ? whole + decimal + parts[1] : whole;
    }

    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_match, name) {
      switch (name) {
        case 'amount':
          return withDelimiters(value, 2, ',', '.');
        case 'amount_no_decimals':
          return withDelimiters(value, 0, ',', '.');
        case 'amount_with_comma_separator':
          return withDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return withDelimiters(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return withDelimiters(value, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator':
          return withDelimiters(value, 0, ' ', ',');
        case 'amount_with_space_separator':
          return withDelimiters(value, 2, ' ', ',');
        default:
          return withDelimiters(value, 2, '.', ',');
      }
    });
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // constants.js deklariert PUB_SUB_EVENTS per `const` — das landet im
  // globalen Lexical Scope, nicht auf window. Deshalb direkt referenzieren.
  function cartEvents() {
    if (typeof subscribe !== 'function') return null;
    return typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null;
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  /* =============================================================
     Toasts
     ============================================================= */

  var toastHost = null;

  function toast(message, kind) {
    if (!message) return;
    if (!toastHost) {
      toastHost = document.createElement('div');
      toastHost.className = 'herb-toasts';
      toastHost.setAttribute('role', 'status');
      toastHost.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastHost);
    }
    var el = document.createElement('div');
    el.className = 'herb-toast';
    if (kind) el.dataset.copyKind = kind;
    el.textContent = message;
    toastHost.appendChild(el);
    window.setTimeout(function () {
      el.classList.add('is-leaving');
      window.setTimeout(function () {
        if (el.parentNode) el.parentNode.removeChild(el);
      }, 250);
    }, 2600);
  }

  window.HerbFXToast = toast;

  /* =============================================================
     1. Scroll-Fortschritt + Zurück-nach-oben
     ============================================================= */

  function initScrollUi() {
    var bar = settings.scroll_progress
      ? document.querySelector('.herb-scroll-progress__bar')
      : null;
    var toTop = settings.back_to_top ? document.querySelector('.herb-to-top') : null;
    var ringValue = toTop ? toTop.querySelector('.herb-to-top__value') : null;
    var ringLength = 0;

    if (ringValue && typeof ringValue.getTotalLength === 'function') {
      ringLength = ringValue.getTotalLength();
      ringValue.style.setProperty('--herb-ring-length', ringLength);
      ringValue.style.setProperty('--herb-ring-offset', ringLength);
    }

    if (!bar && !toTop) return;

    var ticking = false;

    function update() {
      ticking = false;
      var doc = document.documentElement;
      var max = doc.scrollHeight - window.innerHeight;
      var scrolled = window.scrollY || doc.scrollTop || 0;
      var ratio = max > 0 ? Math.min(scrolled / max, 1) : 0;

      if (bar) bar.style.transform = 'scaleX(' + ratio + ')';

      if (toTop) {
        toTop.classList.toggle('is-visible', scrolled > 600);
        if (ringValue && ringLength) {
          ringValue.style.setProperty('--herb-ring-offset', ringLength * (1 - ratio));
        }
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();

    if (toTop) {
      toTop.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    }
  }

  /* =============================================================
     2. Holo-Karteneffekt
     ============================================================= */

  function initHoloCards() {
    if (!settings.holo_cards || reduceMotion || !finePointer) return;

    document.documentElement.setAttribute('data-herb-holo', '');

    var MAX_TILT = 9;
    var active = null;
    var pending = null;
    var frame = null;

    function layerFor(wrapper) {
      // Keep decoration outside .media: Dawn treats extra children as a second image.
      var host = wrapper.querySelector('.card__media');
      if (!host) return null;
      var layer = host.querySelector(':scope > .herb-holo-layer');
      if (!layer) {
        layer = document.createElement('div');
        layer.className = 'herb-holo-layer';
        layer.setAttribute('aria-hidden', 'true');
        layer.innerHTML =
          '<div class="herb-holo-layer__foil"></div><div class="herb-holo-layer__glare"></div>';
        host.appendChild(layer);
      }
      return layer;
    }

    function clear(wrapper) {
      if (!wrapper) return;
      wrapper.classList.remove('is-tilting');
      wrapper.style.removeProperty('--herb-rx');
      wrapper.style.removeProperty('--herb-ry');
    }

    function apply() {
      frame = null;
      if (!pending) return;
      var wrapper = pending.wrapper;
      var rect = wrapper.getBoundingClientRect();
      if (!rect.width || !rect.height) return;

      var px = Math.max(0, Math.min(1, (pending.x - rect.left) / rect.width));
      var py = Math.max(0, Math.min(1, (pending.y - rect.top) / rect.height));

      wrapper.style.setProperty('--herb-rx', (0.5 - py) * MAX_TILT * 2 + 'deg');
      wrapper.style.setProperty('--herb-ry', (px - 0.5) * MAX_TILT * 2 + 'deg');

      var layer = layerFor(wrapper);
      if (layer) {
        layer.style.setProperty('--herb-mx', px * 100 + '%');
        layer.style.setProperty('--herb-my', py * 100 + '%');
      }
      wrapper.classList.add('is-tilting');
    }

    document.addEventListener(
      'pointermove',
      function (event) {
        if (event.pointerType !== 'mouse') return;
        // Nur Karten mit data-herb-holo-card (in Liquid gesetzt) kippen.
        var wrapper = event.target.closest
          ? event.target.closest('.card-wrapper[data-herb-holo-card]')
          : null;

        if (wrapper !== active) {
          clear(active);
          active = wrapper;
        }
        if (!wrapper) { pending = null; return; }

        pending = { wrapper: wrapper, x: event.clientX, y: event.clientY };
        if (!frame) frame = window.requestAnimationFrame(apply);
      },
      { passive: true }
    );

    // Ohne Capture: feuert, wenn der Zeiger das Dokument verlässt.
    document.addEventListener('pointerleave', function () {
      clear(active);
      active = null;
      pending = null;
    });

    window.addEventListener(
      'scroll',
      function () {
        if (active) {
          clear(active);
          active = null;
          pending = null;
        }
      },
      { passive: true }
    );
  }

  /* =============================================================
     3. Wunschliste
     ============================================================= */

  var WISHLIST_KEY = 'herb:wishlist';

  function readWishlist() {
    var list = storageGet(WISHLIST_KEY, []);
    return Array.isArray(list) ? list.filter(function (item) {
      return item && typeof item.handle === 'string' && typeof item.url === 'string' &&
        item.url.charAt(0) === '/' && item.url.charAt(1) !== '/';
    }) : [];
  }

  function productFromElement(el) {
    if (!el) return null;
    var data = el.dataset;
    if (!data.herbProductHandle) return null;
    return {
      handle: data.herbProductHandle,
      title: data.herbProductTitle || data.herbProductHandle,
      url: data.herbProductUrl || '/products/' + data.herbProductHandle,
      image: data.herbProductImage || '',
      price: data.herbProductPrice || '',
    };
  }

  function initWishlist() {
    if (!settings.wishlist) return;

    var drawer = document.querySelector('[data-herb-wishlist-drawer]');
    var body = drawer ? drawer.querySelector('[data-herb-wishlist-body]') : null;
    var counters = document.querySelectorAll('[data-herb-wishlist-count]');
    var previousFocus = null;
    var previousOverflow = '';

    function closeDrawer() {
      if (!drawer || !drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = previousOverflow;
      if (previousFocus && previousFocus.isConnected) previousFocus.focus();
    }

    function syncCounters() {
      var count = readWishlist().length;
      counters.forEach(function (node) {
        node.textContent = count;
        node.classList.toggle('is-visible', count > 0);
      });
    }

    function syncButtons() {
      var handles = readWishlist().map(function (item) {
        return item.handle;
      });
      document.querySelectorAll('[data-herb-wish]').forEach(function (button) {
        var host = button.closest('[data-herb-product-handle]');
        var handle = host ? host.dataset.herbProductHandle : button.dataset.herbProductHandle;
        var active = handles.indexOf(handle) !== -1;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        var productTitle = button.dataset.herbProductTitle || 'Produkt';
        button.setAttribute('aria-label', productTitle + (active ? ' von der Merkliste entfernen' : ' zur Merkliste hinzufügen'));
        var label = button.querySelector('[data-herb-wish-label]');
        if (label) {
          label.textContent = active ? strings.wishlist_saved : strings.wishlist_save;
        }
      });
    }

    function renderDrawer() {
      if (!body) return;
      var list = readWishlist();
      if (!list.length) {
        body.innerHTML =
          '<p class="herb-drawer__empty">' + escapeHtml(strings.wishlist_empty || '') + '</p>';
        return;
      }
      body.innerHTML = list
        .map(function (item) {
          var image = item.image
            ? '<img src="' + escapeHtml(item.image) + '" alt="" loading="lazy" width="70" height="70">'
            : '<span class="herb-wishlist-item__placeholder"></span>';
          return (
            '<div class="herb-wishlist-item" data-herb-wishlist-entry="' +
            escapeHtml(item.handle) +
            '">' +
            image +
            '<div><a class="herb-wishlist-item__title" href="' +
            escapeHtml(item.url) +
            '">' +
            escapeHtml(item.title) +
            '</a><span class="herb-wishlist-item__price">' +
            escapeHtml(item.price) +
            '</span></div>' +
            '<button type="button" class="herb-wishlist-item__remove" data-herb-wishlist-remove="' +
            escapeHtml(item.handle) +
            '" aria-label="' +
            escapeHtml(strings.wishlist_remove || 'Entfernen') +
            '">&times;</button></div>'
          );
        })
        .join('');
    }

    function sync() {
      syncCounters();
      syncButtons();
      renderDrawer();
    }

    function toggle(product) {
      var list = readWishlist();
      var index = -1;
      list.forEach(function (item, i) {
        if (item.handle === product.handle) index = i;
      });
      var added = index === -1;
      if (added) {
        list.unshift(product);
      } else {
        list.splice(index, 1);
      }
      storageSet(WISHLIST_KEY, list);
      sync();
      toast(added ? strings.wishlist_added : strings.wishlist_removed, added ? 'wishlist_added' : 'wishlist_removed');
      return added;
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest ? event.target.closest('[data-herb-wish]') : null;
      if (button) {
        event.preventDefault();
        var host = button.closest('[data-herb-product-handle]') || button;
        var product = productFromElement(host);
        if (product) toggle(product);
        return;
      }

      var remove = event.target.closest
        ? event.target.closest('[data-herb-wishlist-remove]')
        : null;
      if (remove) {
        var handle = remove.dataset.herbWishlistRemove;
        storageSet(
          WISHLIST_KEY,
          readWishlist().filter(function (item) {
            return item.handle !== handle;
          })
        );
        sync();
        if (drawer && drawer.classList.contains('is-open')) drawer.querySelector('button[data-herb-wishlist-close]').focus();
        return;
      }

      var opener = event.target.closest ? event.target.closest('[data-herb-wishlist-open]') : null;
      if (opener && drawer) {
        event.preventDefault();
        previousFocus = opener;
        previousOverflow = document.body.style.overflow;
        renderDrawer();
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        drawer.querySelector('button[data-herb-wishlist-close]').focus();
        return;
      }

      if (
        drawer &&
        drawer.classList.contains('is-open') &&
        event.target.closest &&
        event.target.closest('[data-herb-wishlist-close]')
      ) {
        closeDrawer();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
      if (event.key === 'Tab' && drawer && drawer.classList.contains('is-open')) {
        var focusable = Array.from(drawer.querySelectorAll('a[href],button:not([disabled])')).filter(function (node) {
          return node.getClientRects().length > 0;
        });
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });

    // Andere Tabs im selben Browser halten die Liste synchron.
    window.addEventListener('storage', function (event) {
      if (event.key === WISHLIST_KEY) sync();
    });

    sync();

    // Filter, Sortierung und Quick-Add tauschen Produktkarten per JS aus –
    // die neuen Herzen müssen ihren Zustand nachziehen.
    if ('MutationObserver' in window) {
      var pendingSync = null;
      new MutationObserver(function (records) {
        var touched = records.some(function (record) {
          return record.addedNodes.length > 0;
        });
        if (!touched || pendingSync) return;
        pendingSync = window.setTimeout(function () {
          pendingSync = null;
          syncButtons();
        }, 100);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  /* =============================================================
     4. Warenkorb-Effekte
     ============================================================= */

  var confetti = (function () {
    var canvas = null;
    var ctx = null;
    var particles = [];
    var running = false;

    function ensure() {
      if (canvas) return;
      canvas = document.createElement('canvas');
      canvas.className = 'herb-confetti-canvas';
      canvas.setAttribute('aria-hidden', 'true');
      document.body.appendChild(canvas);
      ctx = canvas.getContext('2d');
      resize();
      window.addEventListener('resize', resize);
    }

    function resize() {
      if (!canvas) return;
      var dpr = window.devicePixelRatio || 1;
      canvas.width = window.innerWidth * dpr;
      canvas.height = window.innerHeight * dpr;
      canvas.style.width = window.innerWidth + 'px';
      canvas.style.height = window.innerHeight + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function tick() {
      if (!particles.length) {
        running = false;
        ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
        return;
      }
      ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
      for (var i = particles.length - 1; i >= 0; i--) {
        var p = particles[i];
        p.vy += 0.32;
        p.vx *= 0.99;
        p.x += p.vx;
        p.y += p.vy;
        p.rotation += p.spin;
        p.life -= 1;
        if (p.life <= 0 || p.y > window.innerHeight + 40) {
          particles.splice(i, 1);
          continue;
        }
        ctx.save();
        ctx.globalAlpha = Math.max(0, Math.min(1, p.life / 45));
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rotation);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.6);
        ctx.restore();
      }
      window.requestAnimationFrame(tick);
    }

    return function burst(x, y) {
      if (reduceMotion) return;
      ensure();
      // Leafeon-Palette: Blattgrün, frisches Grün, Creme, warmes Licht
      var colors = ['#3a7d44', '#7cb342', '#a8d06a', '#d9e8c8', '#faf7ef', '#e8c46a'];
      for (var i = 0; i < 60; i++) {
        var angle = Math.random() * Math.PI * 2;
        var speed = 3 + Math.random() * 8;
        particles.push({
          x: x,
          y: y,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed - 5,
          size: 5 + Math.random() * 6,
          color: colors[(Math.random() * colors.length) | 0],
          rotation: Math.random() * Math.PI,
          spin: (Math.random() - 0.5) * 0.4,
          life: 60 + Math.random() * 40,
        });
      }
      if (!running) {
        running = true;
        window.requestAnimationFrame(tick);
      }
    };
  })();

  function cartTarget() {
    return document.getElementById('cart-icon-bubble') || document.querySelector('.header__icon--cart');
  }

  function flyToCart(sourceImage) {
    if (reduceMotion || !sourceImage || typeof sourceImage.animate !== 'function') return;
    var target = cartTarget();
    if (!target) return;

    var from = sourceImage.getBoundingClientRect();
    var to = target.getBoundingClientRect();
    if (!from.width || !to.width) return;

    var clone = document.createElement('img');
    clone.src = sourceImage.currentSrc || sourceImage.src;
    clone.className = 'herb-fly-image';
    clone.alt = '';
    clone.style.left = from.left + 'px';
    clone.style.top = from.top + 'px';
    clone.style.width = from.width + 'px';
    clone.style.height = from.height + 'px';
    document.body.appendChild(clone);

    var dx = to.left + to.width / 2 - (from.left + from.width / 2);
    var dy = to.top + to.height / 2 - (from.top + from.height / 2);
    var scale = Math.max(0.08, to.width / from.width);

    var animation = clone.animate(
      [
        { transform: 'translate(0, 0) scale(1) rotate(0deg)', opacity: 1 },
        {
          transform:
            'translate(' + dx * 0.55 + 'px, ' + (dy * 0.35 - 90) + 'px) scale(0.6) rotate(-12deg)',
          opacity: 0.95,
          offset: 0.55,
        },
        {
          transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(' + scale + ') rotate(8deg)',
          opacity: 0.2,
        },
      ],
      { duration: 850, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
    );

    animation.onfinish = function () {
      if (clone.parentNode) clone.parentNode.removeChild(clone);
      target.classList.add('herb-cart-pulse');
      window.setTimeout(function () {
        target.classList.remove('herb-cart-pulse');
      }, 650);
      var rect = target.getBoundingClientRect();
      if (settings.confetti) confetti(rect.left + rect.width / 2, rect.top + rect.height / 2);
    };
  }

  function initCartFx() {
    if (!settings.cart_fx) return;

    // Merkt sich das Bild des zuletzt angeklickten "In den Warenkorb"-Buttons,
    // damit der Flug beim cart-update vom richtigen Produkt startet.
    var lastImage = null;

    document.addEventListener(
      'click',
      function (event) {
        var button = event.target.closest
          ? event.target.closest('[name="add"], .product-form__submit, .quick-add__submit')
          : null;
        if (!button) return;
        var scope =
          button.closest('.card-wrapper') ||
          button.closest('.product') ||
          button.closest('quick-add-modal') ||
          document;
        lastImage =
          scope.querySelector('.card__media img') ||
          scope.querySelector('.product__media img') ||
          scope.querySelector('img');
      },
      true
    );

    var events = cartEvents();
    if (events) {
      subscribe(events.cartUpdate, function () {
        flyToCart(lastImage);
      });
    } else {
      document.addEventListener('herb:cart-updated', function () {
        flyToCart(lastImage);
      });
    }
  }

  /* =============================================================
     5. Gratisversand-Fortschritt
     ============================================================= */

  var shippingRefreshVersion = 0;

  function renderShippingBars(totalCents) {
    document.querySelectorAll('[data-herb-shipping-bar]').forEach(function (bar) {
      var threshold = Number(bar.dataset.herbThreshold);
      if (!Number.isFinite(threshold) || threshold <= 0) return;
      var total = typeof totalCents === 'number' ? totalCents : Number(bar.dataset.herbTotal);
      if (!Number.isFinite(total)) return;
      total = Math.max(0, total);
      bar.dataset.herbTotal = total;

      var remaining = Math.max(threshold - total, 0);
      var percent = Math.min(total / threshold * 100, 100);
      var fill = bar.querySelector('.herb-shipping-bar__fill');
      var text = bar.querySelector('.herb-shipping-bar__text');
      var track = bar.querySelector('[role="progressbar"]');
      var current = bar.querySelector('[data-herb-shipping-current]');

      if (fill) fill.style.width = percent + '%';
      bar.classList.toggle('is-complete', remaining === 0);
      if (current) current.textContent = formatMoney(total);
      if (text) {
        var message = remaining === 0 ? escapeHtml(strings.shipping_reached || '') :
          escapeHtml(strings.shipping_remaining || '').replace(/%amount%/g,
            '<strong>' + escapeHtml(formatMoney(remaining)) + '</strong>');
        if (text.innerHTML !== message) text.innerHTML = message;
      }
      if (track) {
        track.setAttribute('aria-valuenow', Math.round(percent));
        track.setAttribute('aria-valuetext', text && text.textContent.trim() || Math.round(percent) + '%');
      }
    });
  }

  function refreshShippingBars() {
    var version = ++shippingRefreshVersion;
    if (!document.querySelector('[data-herb-shipping-bar]')) return;
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return fetch(root + 'cart.js', { cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart unavailable');
        return response.json();
      })
      .then(function (cart) {
        // An earlier request must never overwrite a newer cart update.
        if (version === shippingRefreshVersion && typeof cart.total_price === 'number') {
          renderShippingBars(cart.total_price);
        }
      })
      .catch(function () { /* Keep the last valid server-rendered cart state. */ });
  }

  function initShippingBar() {
    if (!settings.free_shipping_threshold) return;
    renderShippingBars();
    var events = cartEvents();
    if (events) subscribe(events.cartUpdate, refreshShippingBars);

    // Drawer and Theme Editor sections can appear after the initial page load.
    new MutationObserver(function (records) {
      var addedBar = records.some(function (record) {
        return Array.from(record.addedNodes).some(function (node) {
          return node.nodeType === 1 && (node.matches('[data-herb-shipping-bar]') ||
            node.querySelector('[data-herb-shipping-bar]'));
        });
      });
      if (addedBar) {
        renderShippingBars();
        refreshShippingBars();
      }
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) refreshShippingBars();
    });
  }

  /* =============================================================
     6. Zuletzt angesehen
     ============================================================= */

  var RECENT_KEY = 'herb:recently-viewed';

  function initRecentlyViewed() {
    if (!settings.recently_viewed) return;

    var current = config.product;
    var list = storageGet(RECENT_KEY, []);
    if (!Array.isArray(list)) list = [];

    if (current && current.handle) {
      list = list.filter(function (item) {
        return item.handle !== current.handle;
      });
      list.unshift(current);
      list = list.slice(0, 12);
      storageSet(RECENT_KEY, list);
    }

    var container = document.querySelector('[data-herb-recent]');
    if (!container) return;

    var items = list.filter(function (item) {
      return !current || item.handle !== current.handle;
    });

    if (!items.length) return;

    var columns = parseInt(container.dataset.herbRecentColumns, 10) || 5;
    var grid = container.querySelector('[data-herb-recent-grid]');
    if (!grid) return;

    grid.style.setProperty('--herb-recent-columns', columns);
    grid.innerHTML = items
      .slice(0, columns * 2)
      .map(function (item) {
        var image = item.image
          ? '<img src="' + escapeHtml(item.image) + '" alt="" loading="lazy">'
          : '';
        return (
          '<li><a class="herb-recent__card" href="' +
          escapeHtml(item.url) +
          '"><div class="herb-recent__media">' +
          image +
          '</div><p class="herb-recent__title">' +
          escapeHtml(item.title) +
          '</p><span class="herb-recent__price">' +
          escapeHtml(item.price || '') +
          '</span></a></li>'
        );
      })
      .join('');

    container.hidden = false;
  }

  /* =============================================================
     7. Sticky-Kaufleiste
     ============================================================= */

  function initStickyAtc() {
    var bar = document.querySelector('[data-herb-sticky-atc]');
    if (!bar) return;

    var target = document.getElementById(bar.dataset.herbTarget);
    if (!target || !('IntersectionObserver' in window)) {
      bar.parentNode.removeChild(bar);
      return;
    }

    var addButton = bar.querySelector('[data-herb-sticky-add]');
    var priceEl = bar.querySelector('[data-herb-sticky-price]');

    if (addButton) {
      // Den echten Button auslösen: Varianten, Mengenregeln und die
      // Warenkorb-Logik von Dawn bleiben damit unangetastet.
      addButton.addEventListener('click', function () {
        target.click();
      });
    }

    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', scrolledPast);
          // Discord-Button und Zurück-nach-oben anheben, damit die Leiste
          // sie nicht überdeckt.
          document.documentElement.classList.toggle('herb-atc-open', scrolledPast);
        });
      },
      { threshold: 0 }
    ).observe(target);

    var events = cartEvents();
    if (!events) return;

    subscribe(events.variantChange, function (payload) {
      var variant = payload && payload.data && payload.data.variant;
      if (!variant) return;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (addButton) addButton.disabled = variant.available === false;
    });
  }

  /* =============================================================
     8. Suche per Tastenkürzel ("/" oder Strg/Cmd + K)
     ============================================================= */

  function initSearchShortcut() {
    if (!settings.search_shortcut) return;

    document.addEventListener('keydown', function (event) {
      var target = event.target;
      var typing =
        target &&
        (target.tagName === 'INPUT' ||
          target.tagName === 'TEXTAREA' ||
          target.tagName === 'SELECT' ||
          target.isContentEditable);
      if (typing) return;

      var isSlash = event.key === '/' && !event.metaKey && !event.ctrlKey && !event.altKey;
      var isCmdK = (event.metaKey || event.ctrlKey) && (event.key === 'k' || event.key === 'K');
      if (!isSlash && !isCmdK) return;

      var summary = document.querySelector('details-modal.header__search summary');
      var details = summary ? summary.closest('details') : null;
      if (!summary || (details && details.hasAttribute('open'))) return;

      event.preventDefault();
      summary.click();

      window.setTimeout(function () {
        var input = document.querySelector('.search-modal__form input[type="search"]');
        if (input) input.focus();
      }, 120);
    });
  }

  /* =============================================================
     Start
     ============================================================= */

  onReady(function () {
    initScrollUi();
    initHoloCards();
    initWishlist();
    initCartFx();
    initShippingBar();
    initRecentlyViewed();
    initStickyAtc();
    initSearchShortcut();
  });
})();
